module.exports = __webpack_public_path__ + "static/img/kdSimulator_6.fced0dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdSimulator/kdSimulator_6.png
// module id = wXPL
// module chunks = 1